import './HeadlineText.scss';

import { ReactNode } from 'react';

interface HeadlineTextProps {
  background?: string;
  removeTopPadding?: boolean;
  removeBottomPadding?: boolean;
  children: ReactNode;
  theme?: 'dark' | 'light';
  className?: string;
}

const HeadlineText = ({
  background = '',
  removeTopPadding = false,
  removeBottomPadding = false,
  children,
  theme = 'dark',
  className = '',
}: HeadlineTextProps) => {
  const classNames = [
    'headline-text-section',
    background,
    removeTopPadding ? 'pt-0' : '',
    removeBottomPadding ? 'pb-0' : '',
    theme,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <section className={classNames}>
      <div className='container'>
        <div className='headline-text__content row'>
          <div className='headline-text__content-wrapper col-lg-9 col-12'>{children}</div>
        </div>
      </div>
    </section>
  );
};

export default HeadlineText;
